import createMuiTheme from '@material-ui/core/styles/createMuiTheme'

const primaryColor = 'rgb(89,32,99)'
const secondaryColor = 'rgb(0,92,89)'

export const smbOrderFlowTheme = createMuiTheme({
    palette: {
        primary: {
            main: primaryColor,
        },
        secondary: {
            main: secondaryColor,
        },
        black: {
            main: '#222222',
        },
        grey: {
            main: '#F8F8F8',
            secondary: '#747474',
        },
    },
    typography: {
        h1: {
            margin: '1rem 0',
            fontSize: '2rem',
            fontWeight: 'bold',
            '@media (min-width:600px)': {
                fontSize: '3rem',
            },
        },
        h2: {
            margin: '1.5rem 0 1rem 0',
            fontSize: '1.5rem',
            fontWeight: 'bold',
        },
        body1: {
            fontSize: '1.1rem',
        },
        button: {
            fontWeight: 'bold',
            textTransform: 'none',
        },
    },
    overrides: {
        MuiCssBaseline: {
            '@global': {
                body: {
                    backgroundColor: '#ffffff',
                },
            },
        },
        MuiInput: {
            underline: {
                '&:before': {
                    borderBottom: 'none',
                },
                '&:after': {
                    borderBottom: 'none',
                },
                '&:hover:not(.Mui-disabled):before': {
                    borderBottom: 'none',
                },
            },
        },
        MuiButton: {
            outlinedPrimary: {
                borderColor: primaryColor,
                borderWidth: '2px',
                '&:hover': {
                    borderWidth: '2px',
                },
            },
            outlinedSizeLarge: {
                fontSize: '1rem',
            },
            containedSizeLarge: {
                fontSize: '1rem',
            },
        },
        MuiTooltip: {
            tooltip: {
                backgroundColor: '#747474',
            },
        },
        MuiStepLabel: {
            label: {
                textTransform: 'uppercase',
                color: 'rgba(255, 255, 255, 0.5)',
                '&$active': {
                    color: 'white',
                },
                '&$completed': {
                    color: 'white',
                },
            },
        },
    },
})

export const rootStyles = {
    palette: {
        background: {
            default: '#FFFFFF',
        },
    },
    root: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '70vh',
        padding: 0,
        backgroundColor: '#FFF',
        '& img': {
            display: 'block',
            maxWidth: '100%',
        },
    },
    cobrandCardsLandingPageRoot: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '70vh',
        padding: 0,
        '& img': {
            display: 'block',
            maxWidth: '100%',
        },
    },
    cobrandBuilderRoot: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '70vh',
        paddingTop: '2rem',
        paddingBottom: '2rem',
        '& img': {
            display: 'block',
            maxWidth: '100%',
        },
    },
}
